<template>
  <div class="container">
    <h3 class="mt-3 mb-5 d-none d-md-flex">Ubah Profil</h3>
    <v-form ref="form" method="post" @submit.prevent class="mt-2">
      <v-text-field
        outlined
        :value="user.name"
        label="Nama Lengkap"
        v-model="name"
      ></v-text-field>
      <v-text-field
        outlined
        :value="user.nim"
        label="NIM"
        v-model="nim"
      ></v-text-field>
      <v-text-field
        outlined
        :value="user.email"
        label="E-Mail"
        v-model="email"
      ></v-text-field>
      <v-text-field
        outlined
        :value="user.phone_number"
        label="Telepon"
        v-model="telepon"
      ></v-text-field>
      <v-autocomplete
        outlined
        label="Universitas"
        item-text="name"
        item-value="id"
        v-model="universitySelect"
        :items="universities"
      ></v-autocomplete>
      <v-select
        outlined
        label="Fakultas"
        item-text="faculty_name"
        item-value="id"
        v-model="facultySelect"
        :items="faculties"
      ></v-select>
      <v-btn @click="saveData" :loading="saveLoading" block color="primary"
        >Simpan</v-btn
      >
    </v-form>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'MyAccountEdit',
  data() {
    return {
      user: [],
      token: 'Bearer ' + localStorage.getItem('token'),
      message: null,
      telepon: null,
      email: null,
      nim: null,
      name: null,
      facultySelect: [],
      faculties: [],
      saveLoading: false,
      universities: [],
      universitySelect: [],
    };
  },
  mounted() {
    // get data user
    Axios.get(process.env.VUE_APP_API + 'user/', {
      headers: {
        Authorization: this.token,
      },
    })
      .then((response) => {
        this.user = response.data.data;
        // console.log(response.data);
        this.name = this.user.name;
        this.nim = this.user.nim;
        this.email = this.user.email;
        this.telepon = this.user.phone_number;
        this.facultySelect = this.user.university_college_id;
        this.universitySelect = this.user.university_id;
      })
      .catch((error) => {
        console.log(error);
      });

    // get data university
    Axios.get(process.env.VUE_APP_API + 'university/all', {
      headers: {
        Authorization: this.token,
      },
    })
      .then((response) => {
        this.universities = response.data;
        // console.log(this.universities);

        this.getFaculty(this.universitySelect);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    getFaculty(university_id) {
      // get data faculty for dropdown
      Axios.get(process.env.VUE_APP_API + 'faculty/' + university_id, {
        headers: {
          Authorization: this.token,
        },
      })
        .then((response) => {
          this.faculties = response.data;
          // console.log(this.faculties);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      // set loading
      this.saveLoading = true;

      let storeData = {
        name: this.name,
        nim: this.nim,
        email: this.email,
        phone_number: this.telepon,
        university_id: this.universitySelect,
        university_college_id: this.facultySelect,
      };
      // console.log(storeData);

      Axios.patch(process.env.VUE_APP_API + 'user/', storeData, {
        headers: {
          Authorization: this.token,
        },
      })
        .then(() => {
          console.log('success');
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => ((this.saveLoading = false), this.$router.go(-1)));
    },
  },
  watch: {
    universitySelect() {
      // console.log(this.universitySelect);
      this.getFaculty(this.universitySelect);
    },
  },
};
</script>

<style scoped></style>
